import { useUser } from '../../hooks/use-user';
import { UserType } from '../../lib/interfaces/user';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Button } from '../../ui/components/ui/button';
import SearchInput from '../../ui/components/ui/search-input';
import AddCustomerUserForm from './customer/add-user';
import CustomerUserFetchParent from './customer/user-fetcher';
import AddInternalUserFormParent from './internal/add-user';
import InternalUserFetchParent from './internal/user-fetcher';
import { Link, useSearchParams } from 'react-router-dom';

const Collaborators = () => {
  const { user } = useUser();
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);
  const [invitationCount, setInvitationCount] = useState(0);

  useEffect(() => {
    // rerender
  }, [reload]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <div className="flex justify-between">
        <div>
          <CollaboratorFilters setSearchQuery={setSearchQuery} />
        </div>
        <div className="flex gap-3">
          <Button asChild variant="outline">
            <Link to="/collaborators/invitations">{invitationCount + (invitationCount === 1 ? ' Einladung' : ' Einladungen') + ' anzeigen'}</Link>
          </Button>
          <>
            {user?.userType === UserType.Customer ? (
              <AddCustomerUserForm setReload={setReload} />
            ) : (
              <AddInternalUserFormParent setReload={setReload} />
            )}
          </>
        </div>
      </div>
      <>
        {user?.userType === UserType.Customer ? (
          <CustomerUserFetchParent setInvitationCount={setInvitationCount} searchQuery={searchQuery} />
        ) : (
          <InternalUserFetchParent setInvitationCount={setInvitationCount} searchQuery={searchQuery} />
        )}
      </>
    </div>
  );
};

const CollaboratorFilters = ({ setSearchQuery }: { setSearchQuery: Dispatch<SetStateAction<string>> }) => {
  const [firstRender, setFirstRender] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get('textSearch') || '');
  const [filtersChanged, setFiltersChanged] = useState(false);

  useEffect(() => {
    if (!firstRender) return;

    const textSearch = searchParams.get('textSearch') || '';

    setSearchText(textSearch);
    setFirstRender(false);
  }, [searchParams, firstRender]);

  useEffect(() => {
    if (firstRender) return;

    setFiltersChanged(true);
  }, [searchText, firstRender]);

  // Sync state changes to `searchParams`
  useEffect(() => {
    if (firstRender) return;

    const params = new URLSearchParams();

    if (searchText) params.set('textSearch', searchText);
    params.set('page', filtersChanged ? '1' : searchParams.get('page') || '1');

    // Update URL parameters only if they differ
    const queryString = params.toString();
    setSearchQuery(queryString);
    setSearchParams(params);
    setFiltersChanged(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersChanged, setSearchParams, setSearchQuery, firstRender, searchParams]);

  return (
    <div className="flex items-center gap-4">
      <SearchInput setSearchText={setSearchText} searchText={searchText} />
    </div>
  );
};

export default Collaborators;
